<template>
    <div class="item_sidebar sidebar_animation_item" >
        <div class="title title_m_b">{{title}}:</div>
        <div class="wrapper_body wrapper_body_block">
            <div class="item">
                <div id="field1" class="field margin_top_side w_100">
                    <div class="title">Rotate X:</div>
                    <div class="wrapper_input">
                        <button type="button" id="sub" class="sub" @click="numberMinus('rotateX')">
                            <img :src="require('@/assets/page/img/sub_icon.svg')"/>
                        </button>
                        <input type="number" id="1" :value.number="value.rotateX" @change="updatedData($event.target.value, 'rotateX')"/>
                        <button type="button" id="add" class="add" @click="numberPlus('rotateX')">
                            <img :src="require('@/assets/page/img/add_icon.svg')"/>
                        </button>
                    </div>
                </div>
            </div>
            <div class="item">
                <div id="field1" class="field margin_top_side w_100">
                    <div class="title">Rotate Y:</div>
                    <div class="wrapper_input">
                        <button type="button" id="sub" class="sub" @click="numberMinus('rotateY')">
                            <img :src="require('@/assets/page/img/sub_icon.svg')"/>
                        </button>
                        <input type="number" id="1" :value.number="value.rotateY" @change="updatedData($event.target.value, 'rotateY')"/>
                        <button type="button" id="add" class="add" @click="numberPlus('rotateY')">
                            <img :src="require('@/assets/page/img/add_icon.svg')"/>
                        </button>
                    </div>
                </div>
            </div>
            <div class="item">
                <div id="field1" class="field margin_top_side w_100">
                    <div class="title">Rotate Z:</div>
                    <div class="wrapper_input">
                        <button type="button" id="sub" class="sub" @click="numberMinus('rotateZ')">
                            <img :src="require('@/assets/page/img/sub_icon.svg')"/>
                        </button>
                        <input type="number" id="1" :value.number="value.rotateZ" @change="updatedData($event.target.value, 'rotateZ')"/>
                        <button type="button" id="add" class="add" @click="numberPlus('rotateZ')">
                            <img :src="require('@/assets/page/img/add_icon.svg')"/>
                        </button>
                    </div>
                </div>
            </div>
            <div class="item">
                <div id="field1" class="field margin_top_side w_100">
                    <div class="title">Scale X:</div>
                    <div class="wrapper_input">
                        <button type="button" id="sub" class="sub" @click="numberMinus('scaleX')">
                            <img :src="require('@/assets/page/img/sub_icon.svg')"/>
                        </button>
                        <input type="number" id="1" :value.number="value.scaleX" @change="updatedData($event.target.value, 'scaleX')"/>
                        <button type="button" id="add" class="add" @click="numberPlus('scaleX')">
                            <img :src="require('@/assets/page/img/add_icon.svg')"/>
                        </button>
                    </div>
                </div>
            </div>
            <div class="item">
                <div id="field1" class="field margin_top_side w_100">
                    <div class="title">Scale Y:</div>
                    <div class="wrapper_input">
                        <button type="button" id="sub" class="sub" @click="numberMinus('scaleY')">
                            <img :src="require('@/assets/page/img/sub_icon.svg')"/>
                        </button>
                        <input type="number" id="1" :value.number="value.scaleY" @change="updatedData($event.target.value, 'scaleY')"/>
                        <button type="button" id="add" class="add" @click="numberPlus('scaleY')">
                            <img :src="require('@/assets/page/img/add_icon.svg')"/>
                        </button>
                    </div>
                </div>
            </div>
            <div class="item">
                <div id="field1" class="field margin_top_side w_100">
                    <div class="title">Scale Z:</div>
                    <div class="wrapper_input">
                        <button type="button" id="sub" class="sub" @click="numberMinus('scaleZ')">
                            <img :src="require('@/assets/page/img/sub_icon.svg')"/>
                        </button>
                        <input type="number" id="1" :value.number="value.scaleZ" @change="updatedData($event.target.value, 'scaleZ')"/>
                        <button type="button" id="add" class="add" @click="numberPlus('scaleZ')">
                            <img :src="require('@/assets/page/img/add_icon.svg')"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TransformationInput',
    components: {
    },
    props: ['title', 'value'],
    data: function(){
        return {
            transformationData: this.value,
        }
    },
    methods: {
        updatedData(val, fieldName){
            this.transformationData[fieldName] = +val;

            for (var key in this.transformationData) {
                if(this.transformationData[key] > 360) this.transformationData[key] = 360;
            }

            this.$emit('updated', this.transformationData);
        },
        numberMinus(name){
            if(this.transformationData[name] > 0) this.transformationData[name] -= 1;
            this.updatedData();
        },
        numberPlus(name){
            if(this.transformationData[name] <= 360) this.transformationData[name] += 1;
            // this.transformationData[name] += 1;
            this.updatedData();
        },
        // created(){
        //     this.transformationData = JSON.parse(JSON.stringify(this.value));
        // }
    },
}
</script>